import Footer from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/Footer/Footer"
import Hero from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/Hero"
import MissionOverview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/Mission/MissionOverview"
import MissionTimeline from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/Mission/MissionTimeline"
import NewsFeedGroup from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/NewsFeed/NewsFeedGroup"
import NewsFeedOverview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/NewsFeed/NewsFeedOverview"
import Overview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/Overview"

const SitecraftTemplate = () => {
  return (
    <div className="flex flex-col">
      <Hero  />
    <Overview  />
    <div className="grid gap-4 mt-12">
      <MissionOverview  />
      <MissionTimeline  />
    </div>
    <div className="flex flex-col gap-4 lg:gap-8 my-12">
      <NewsFeedOverview  />
      <NewsFeedGroup  />
    </div>

    <Footer  />
    </div>
  )
}

export default SitecraftTemplate